import React, { useEffect, useState } from "react";
import { FormControlLabel } from "@material-ui/core";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomButton from "../../../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationSettings,
  updateNotificationSettings,
} from "../../../../redux/actions/settingsActions";
import { ButtonLoader } from "../../../../components/ButtonLoader";
import cogoToast from "cogo-toast";

const Notificationsd = () => {
  const dispatch = useDispatch();
  const { notificationSettings } = useSelector(({ settings }) => settings);
  const [saving, setSaving] = useState();
  const [state, setState] = useState({
    all_notification: "0",
    email_notification: "0",
    sms_notification: "0",
    workbrook_updates: "0",
    push_notification: "0",
  });

  console.log("notifications", notificationSettings);

  useEffect(() => {
    getNotificationSettings(dispatch);
  }, [dispatch]);

  useEffect(() => {
    setState({
      all_notification: notificationSettings.all_notification,
      email_notification: notificationSettings.email_notification,
      sms_notification: notificationSettings.sms_notification,
      workbrook_updates: notificationSettings.workbrook_updates,
      push_notification: notificationSettings.push_notification || "0",
    });
  }, [notificationSettings]);

  const handleChange = (event) => {
    const checked = event.target.checked;
    const name = event.target.name;

    console.log("Chkd", checked);

    const newState = { ...state, [event.target.name]: checked ? "1" : "0" };

    // If turning off any individual notification, also turn off all_notifications
    if (!checked && (name === 'email_notification' || name === 'sms_notification' || name === 'workbrook_updates' || name === 'push_notification')) {
      newState.all_notification = "0";
    }

    setState(newState);
  };

  const handleAllNotifications = (event) => {
    const checked = event.target.checked;

    if (checked) {
      setState({
        ...state,
        ...{
          all_notification: "1",
          email_notification: "1",
          sms_notification: "1",
          workbrook_updates: "1",
          push_notification: "1",
        },
      });
    } else {
      setState({
        ...state,
        ...{
          all_notification: "0",
          email_notification: "0",
          sms_notification: "0",
          workbrook_updates: "0",
          push_notification: "0",
        },
      });
    }
  };

  const handleClick = () => {
    setSaving(true);

    console.log("State", state);

    Promise.resolve(updateNotificationSettings(dispatch, state)).then(() => {
      setSaving(false);
      cogoToast.success("Notification settings saved successfully!");
    });
  };

  return (
    <div>
      <h6 className="bolder-text">Notifications</h6>
      <p className="small-text co-darkgray mt-3">
        We advice that you turn on notifications to receive the latest
        opportunities and updates on your applications.
      </p>

      {/* Turn on all notifications */}
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <strong>Turn on all notifications</strong>
          <p className="small-text co-darkgray mb-0">Enable all notification types (Email + In-app)</p>
        </div>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={!!parseInt(state.all_notification)}
              onChange={handleAllNotifications}
              name="all_notification"
            />
          }
        />
      </div>

      {/* Email */}
      <div className="d-flex align-items-center justify-content-between mb-3 ml-3">
        <div>
          Email Notifications
          <p className="small-text co-darkgray mb-0">Receive notifications via email</p>
        </div>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={!!parseInt(state.email_notification)}
              onChange={handleChange}
              name="email_notification"
            />
          }
        />
      </div>

      {/* Turn on notifications (Push) */}
      <div className="d-flex align-items-center justify-content-between mb-3 ml-3">
        <div>
          In-app Notifications
          <p className="small-text co-darkgray mb-0">Receive notifications within the app</p>
        </div>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={!!parseInt(state.push_notification)}
              onChange={handleChange}
              name="push_notification"
            />
          }
        />
      </div>

      <div className="d-flex mt-5 justify-content-end">
        <span className="w-25">
          <CustomButton
            handleClick={handleClick}
            text={saving ? <ButtonLoader /> : "Save"}
            backgroundColor="#3a6ed4"
            color="#fff"
          />
        </span>
      </div>
    </div>
  );
};

export default Notificationsd;